import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import api from "./api";

const cards = [
  { key: "clientes", label: "Clientes", icon: "fa-users", color: "var(--iev-primary)", link: "/admin/clientes" },
  { key: "boletos_pendentes", label: "Boletos pendentes", icon: "fa-file-invoice-dollar", color: "var(--iev-amber)", link: "/admin/boletos" },
  { key: "boletos_pagos", label: "Boletos pagos", icon: "fa-circle-check", color: "var(--iev-green)", link: "/admin/boletos" },
  { key: "tickets_abertos", label: "Chamados abertos", icon: "fa-headset", color: "var(--iev-blue)", link: "/admin/helpdesk" },
];

const OplenaDashboard = () => {
  const [stats, setStats] = useState({});
  useEffect(() => { api.get("/oplena/stats").then(setStats).catch(() => {}); }, []);

  return (
    <div className="page-content">
      <Container fluid>
        <h4 className="fw-bold mb-1">Bem-vindo</h4>
        <p className="text-muted">Resumo do seu atendimento.</p>
        <Row className="g-3">
          {cards.map((c) => (
            <Col key={c.key} md={6} xl={3}>
              <Card as={Link} to={c.link} className="text-decoration-none">
                <CardBody className="d-flex align-items-center gap-3">
                  <span style={{ width: 52, height: 52, borderRadius: 12, background: c.color, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 20 }}>
                    <i className={`fa-solid ${c.icon}`} />
                  </span>
                  <div>
                    <div className="fs-3 fw-bold" style={{ color: "var(--iev-text)" }}>{stats[c.key] ?? "—"}</div>
                    <small className="text-muted">{c.label}</small>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default OplenaDashboard;
